import { t as closeOpenLocker } from "./app.shared-CsqTb1qy.js";

import { a as createModalRequestId, i as MODAL_OPEN_REQUEST_EVENT } from "./app.shared-B8Jzio6x.js";

import { i as isBisEnabled, n as getVariantStatus, t as applyProductFormButtonState } from "./app.shared-qDp0vS1A.js";

function resolve() {
    if (!window.MBF?.cart) console.warn("[cart] window.MBF.cart is not initialised yet");
    const c = window.MBF?.cart;
    if (!c) throw new Error("[cart] not initialised");
    return c;
}

var addToCart = (input, opts) => resolve().add(input, opts);

var product_form_default = (() => {
    if (!customElements.get("product-form")) customElements.define("product-form", class ProductForm extends HTMLElement {
        form=this.querySelector("form");
        currentVariant=false;
        connectedCallback() {
            this.form.addEventListener("submit", this.onSubmitHandler);
            document.addEventListener("variant:change", this.onVariantChange);
            this.inModal = !!this.closest(".ajax-modal");
        }
        disconnectedCallback() {
            this.form?.removeEventListener("submit", this.onSubmitHandler);
            document.removeEventListener("variant:change", this.onVariantChange);
        }
        onVariantChange=event => {
            if (!!event.detail.modal !== this.inModal) return;
            if (+this.dataset.productId !== event.detail.productId) return;
            this.currentVariant = event.detail.variant;
            this.querySelector('[name="id"]').value = this.currentVariant?.id || "";
            this.querySelectorAll("wishlist-button[data-variant-id]").forEach(el => {
                el.dataset.variantId = this.currentVariant?.id || "";
                const cents = this.currentVariant?.price;
                if (Number.isFinite(cents) && cents > 0) el.dataset.productPrice = String(cents / 100);
                el.syncMembership?.();
            });
            this.updateButton(this.getVariantStatus());
            if (event.detail.userInitiated && this.currentVariant && !this.currentVariant.available && this.canNotify() && this.dataset.bisHandle !== "launch") this.openOOSModal();
        };
        canNotify=() => isBisEnabled() && this.dataset.bisDisabled !== "true";
        getVariantStatus=() => getVariantStatus(this.currentVariant, this.canNotify(), this.dataset.bisHandle || "");
        updateButton=status => {
            if (this.dataset.appExclusive === "true") return;
            applyProductFormButtonState(this.querySelectorAll("[data-atc]"), status, {
                restock: this.dataset.bisOverrideLabel || this.dataset.bisRestockLabel,
                launch: this.dataset.bisOverrideLabel || this.dataset.bisLaunchLabel,
                notifyMe: this.dataset.bisOverrideLabel
            });
        };
        onSubmitHandler=async event => {
            event.preventDefault();
            if (this.dataset.bisHandle === "launch" && this.canNotify() || this.currentVariant && !this.currentVariant.available && this.canNotify()) {
                this.openOOSModal();
                return;
            }
            closeOpenLocker();
            await addToCart(this.form).catch(() => {});
        };
        openOOSModal=() => {
            if (!this.dataset.url) return;
            const url = new URL(this.dataset.url, window.location.origin);
            if (this.currentVariant?.id) url.searchParams.set("variant", this.currentVariant.id);
            window.dispatchEvent(new CustomEvent(MODAL_OPEN_REQUEST_EVENT, {
                detail: {
                    requestId: createModalRequestId(),
                    baseUrl: url.toString(),
                    view: "out-of-stock",
                    strategy: "stack",
                    context: "out-of-stock",
                    source: {
                        type: "product-form",
                        id: `product-form-${this.dataset.productId}`,
                        context: "out-of-stock"
                    }
                }
            }));
        };
    });
})();